import { NOTIFICATION_STATUSES_KEYS, NotificationStatuses } from 'constants/notifications';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { formatInputInTz } from 'utils/date';

type NotificationPopperListItemFileSecondaryProps = {
  createdAt: number;
  fileExtension?: string;
  status: NotificationStatuses;
  isSuccess: boolean;
  isFailure: boolean;
};

export const NotificationPopperListItemFileSecondary: React.FC<
  NotificationPopperListItemFileSecondaryProps
> = ({ status, fileExtension, createdAt, isSuccess, isFailure }) => {
  const translate = useTypedTranslate();

  return (
    <Stack flexDirection="row" gap={1}>
      <Typography>{formatInputInTz(createdAt, { format: 'dd.MM.yyyy HH:mm' })}</Typography>
      <Typography>&bull;</Typography>
      {fileExtension && (
        <>
          <Typography>{fileExtension}</Typography>
          <Typography>&bull;</Typography>
        </>
      )}
      <Typography color={isSuccess ? 'success.main' : isFailure ? 'error.main' : undefined}>
        {translate(NOTIFICATION_STATUSES_KEYS[status])}
      </Typography>
    </Stack>
  );
};
